<div class="messengers row">
  <fieldset [disabled]="!editMode" class="form__fieldset">
    <form [formGroup]="form">
      <label
        *ngIf="!personalTab"
        for="phone"
        class="label-input phone-input plr-12"
        [class.col-5]="personalTab"
        >Phone number</label
      >
      <label
        *ngIf="personalTab"
        appMarkAsterisk
        [formGroup]="form"
        [controlName]="'phoneNumber'"
        [touched]="form.controls['phoneNumber']!.touched"
        for="phone"
        class="label-input phone-input plr-12"
        [class.col-5]="personalTab"
        >Phone number</label
      >
      <div
        class="input__wrapper"
        [class.input__wrapper_personal-tab]="personalTab"
      >
        <input
          type="text"
          id="phone"
          formControlName="phoneNumber"
          class="input__basic"
          placeholder=" "
          (blur)="onCheckChange()"
          [mask]="phoneMask"
          [patterns]="phonePatterns"
        />
        <app-error-field
          *ngIf="personalTab"
          [displayError]="
            form.controls['phoneNumber']!.invalid &&
            form.controls['phoneNumber']!.touched
          "
          [errorMessage]="'The field is required'"
        ></app-error-field>
      </div>
      <div class="dropdown" #messengers>
        <input
          type="text"
          class="dropdown__value"
          [class.pointer]="editMode"
          value="Messenger"
          readonly
          (click)="showItems()"
        />
        <i
          class="icon-arrow"
          *ngIf="editMode"
          [class.icon-arrow_rotate]="visibleContent"
        ></i>
        <div class="dropdown__show-hide" *ngIf="visibleContent">
          <div class="options">
            <div>
              <label class="label-check">
                <input
                  class="check_input"
                  type="checkbox"
                  formControlName="isTelegram"
                  (change)="onCheckChange()"
                />
                <span class="check_box"></span>
                <span class="checked">Telegram</span>
              </label>
            </div>
            <div>
              <label class="label-check">
                <input
                  class="check_input"
                  type="checkbox"
                  formControlName="isViber"
                  (change)="onCheckChange()"
                />
                <span class="check_box"></span>
                <span class="checked">Viber</span>
              </label>
            </div>
            <div>
              <label class="label-check">
                <input
                  class="check_input"
                  type="checkbox"
                  formControlName="isWhatsApp"
                  (change)="onCheckChange()"
                />
                <span class="check_box"></span>
                <span class="checked">WhatsApp</span>
              </label>
            </div>
          </div>
        </div>
      </div>
      <div class="messengers__icons">
        <img
          src="assets/icons/svg/messengers/telegramm.svg"
          *ngIf="form.controls['isTelegram'].value"
          class="messengers__icon"
          alt="telegram"
        />
        <img
          src="assets/icons/svg/messengers/viberr.svg"
          *ngIf="form.controls['isViber'].value"
          class="messengers__icon"
          alt="viber"
        />
        <img
          src="assets/icons/svg/messengers/whatsapp.svg"
          *ngIf="form.controls['isWhatsApp'].value"
          class="messengers__icon"
          alt="whatsapp"
        />
      </div>
      <img
        *ngIf="personalTab && editMode"
        class="trash"
        src="assets/icons/svg/trash/ion_trash-bin.svg"
        alt="trash"
        (click)="removePhone.emit()"
      />
    </form>
  </fieldset>
</div>
